<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton icon="fa-plus" v-on:click="onClickButton" />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <AcessoryList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import AcessoryList from "@/components/settings/test-registers/acessories/AcessoriesList";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "AcessoryListView",
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    AcessoryList,
  },
  methods: {
    onClickButton(e) {
      this.$router.push({ name: "addacessory" });
    },
  },
};
</script>
